import { graphql } from "../gql";

export const createAuditRuleMutationDoc = graphql(`
  mutation uiCreateRuleV2($input: GQLAuditRuleInput!) {
    uiCreateRuleV2(input: $input) {
      id
      name
      status
      selectCodeStr
      evaluateCodeStr
      ruleCodeTestResults
      createdAt
      createdBy
    }
  }
`);
